<template>
    <div class="index">
        <c_Nav :city-code="cityCode" :Index="Index"></c_Nav>
        <c_NewMessage></c_NewMessage>
        <c_CarType></c_CarType>
        <c_HotCars></c_HotCars>
        <c_OurAd></c_OurAd>
        <c_ContactUs :public-data="publicData"></c_ContactUs>
        <c_Epbg :public-data="publicData"></c_Epbg>
        <!--<c_Honor :public-data="publicData"></c_Honor>-->
    </div>
</template>

<script>
    import c_Nav from '@/components/Nav/Nav'
    import c_NewMessage from '@/components/NewMessage/NewMessage'
    import c_CarType from '@/components/CarType/CarType'
    import c_HotCars from '@/components/HotCars/HotCars'
    import c_OurAd from '@/components/OurAd/OurAd'
    import c_ContactUs from '@/components/ContactUs/ContactUs'
    import c_Epbg from '@/components/Epbg/Epbg'
    import c_Honor from '@/components/Honor/Honor'

    export default {
        name: 'Index',
        props:['publicData','cityCode'],
        components:{c_Nav,c_NewMessage,c_CarType,c_HotCars,c_OurAd,c_ContactUs,c_Epbg,c_Honor},
        data () {
            return {
                Index:0
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .clear {overflow: hidden;}
    .clearfix:before, .clearfix:after {clear: both;content: " ";display: table;}

    .carType{margin-bottom: 60px;}
    .hotCars{margin-bottom: 36px}
    .ourAd,.contactUs{margin-bottom: 40px;}
</style>



// WEBPACK FOOTER //
// src/components/Index/Index.vue